import {Component, OnInit} from "@angular/core";
import {AsiDialogService} from "@asi-ngtools/lib";
import {UpdatePasswordModal} from "./../update-password-modal/update-password-modal";

import {
    DAYS_BEFORE_EXPIRE_KEY,
    IS_FIRST_CONNECTION_KEY,
    UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY
} from "../../resources/auth/resources.auth";

import {CerbaCookieService} from "../../services/cerbacookie.service";
import {CookieConstantes} from "../../constantes/cookie.constantes";




@Component({
    selector: 'update-password-component',
    templateUrl: './update-password-component.html'
})
export class UpdatePasswordComponent implements OnInit {
    daysBeforeExpire: string | null | undefined;
    firstConnection: string | null | undefined;

    constructor(private asiDialogService: AsiDialogService, private cookieService: CerbaCookieService) {
    }


    openModale() {
        this.asiDialogService.fromComponent(UpdatePasswordModal, null);
    }

    isEmpty(str: string) {
        return str == 'null' || str == 'undefined' || str == '' || str == null;
    }

    ngOnInit() {

        if (this.isOriginalAuthentication()) {

            this.daysBeforeExpire = localStorage.getItem(DAYS_BEFORE_EXPIRE_KEY);
            this.firstConnection = localStorage.getItem(IS_FIRST_CONNECTION_KEY);

            if (this.firstConnection && this.firstConnection == 'false') {

                if (!localStorage.getItem(UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY)) {
                    if (this.isEmpty(this.daysBeforeExpire)) {
                        localStorage.setItem(UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY, false + '');
                    } else {
                        localStorage.setItem(UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY, true + '');
                    }
                }
            }

            if ((this.daysBeforeExpire && parseInt(this.daysBeforeExpire) == 0) || (this.firstConnection && this.firstConnection == 'true')) {
                this.asiDialogService.fromComponent(UpdatePasswordModal, null);
            } else {
                if (localStorage.getItem(UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY) == true + '' && !this.isAlreadyShownAlert()) {
                    this.asiDialogService.fromComponent(UpdatePasswordModal, null);
                    localStorage.setItem(UPDATE_PASSWORD_ALERTE_VISIBILITY_KEY, false + '');
                }
            }
        }
    }

    hasValue() {
        return parseInt(this.daysBeforeExpire) > 0;
    }

    getDifferenceInDays(date1 : number, date2 : number) {
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / (1000 * 60 * 60 * 24);
    }

    isAlreadyShownAlert(){
        let updatePasswordAlertCookieValue = this.cookieService.getCoockieValue(CookieConstantes.UPDATE_PASSWORD_ALERT_COOKIE);
        if(updatePasswordAlertCookieValue){
           try{
               return !this.isCookieExpired(updatePasswordAlertCookieValue);
           } catch (e){
                console.error("Erreur lors de la lecture du cookie "+ e)
           }
        }
        return false;
    }

    private isCookieExpired(updatePasswordAlertCookieValue: string) {
        let date = new Date(updatePasswordAlertCookieValue);
        let now = new Date();
        return this.getDifferenceInDays(now.getMilliseconds(), date.getMilliseconds()) > 1;
    }

    isOriginalAuthentication() {
        let currentAuthenticationCookie = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
        let originalAuthenticationCookie = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_ORIGINAL);

        return !this.isEmpty(currentAuthenticationCookie) && this.isEmpty(originalAuthenticationCookie);
    }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/update-password/update-password-component.ts